import { useSelector } from 'react-redux';
import { selectUser, selectUserTeam } from '../../slices/auth';
import { SponsorRow } from '../../components/sponsor-row/sponsor-row';
import { SponsorPlacements } from '../../utils/constants';
import DashboardAnnouncement from '../../components/dashboard-announcement';
import { NavLink, Outlet } from 'react-router-dom';
import { useGetAllGamesQuery, useGetStudentInGameNameByIdQuery } from '../../slices/gameApiSlice';
import { useGetAllTeamsQuery } from '../../slices/teamsApiSlice';
import { warn } from 'console';

function StudentDashboard() {
  const user = useSelector(selectUser);
  const team = useSelector(selectUserTeam);

  const { data: studentInGameNames, isLoading: inGameNamesLoading } =
    useGetStudentInGameNameByIdQuery(user.id);
  const { data: gamesData, isLoading: gamesLoading } = useGetAllGamesQuery('');
  const { data: teamData, isLoading: teamsLoading } = useGetAllTeamsQuery({
    query: {},
    noPagination: true,
    showMy: true,
  });

  const profileWarning =
    (!gamesLoading &&
      !teamsLoading &&
      !inGameNamesLoading &&
      [
        ...new Set(
          user.team
            .filter(
              (team: any) =>
                !studentInGameNames
                  ?.map((inGameName: { game_id: any }) => inGameName.game_id)
                  .includes(team.game_id),
            )
            .map((team: any) => team.game_id),
        ),
      ].length) ||
    0;

  const tabs = [
    { name: 'Schedule', link: './schedule/' },
    { name: 'My Profile', link: './profile', warning: profileWarning > 0 },
    { name: 'Teams', link: './teams/' },
    { name: 'My Seasons', link: './seasons/' },
  ];
  return (
    <>
      <div className='flex flex-col p-10 gap-10'>
        <SponsorRow name={SponsorPlacements.Dashboard} />
        <DashboardAnnouncement />
        <div className='flex flex-col gap-10'>
          <div>
            <div className='flex'>
              {tabs.map((tab) => {
                return (
                  <NavLink
                    key={tab.link}
                    to={tab.link}
                    className={`tabs ${tab === tabs[tabs.length - 1] ? 'last' : ''}`}
                  >
                    <div className='flex items-center gap-2'>
                      {tab.name}
                      {tab.warning && <span className='text-sm text-red-600 font-bold'>(!)</span>}
                    </div>
                  </NavLink>
                );
              })}
              <div className='border-b-2 w-full flex justify-end'></div>
            </div>
            <div className='border-2 border-t-0 p-4 border-grey-300'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentDashboard;
